import request from "@/utils/request";
//获取销售合同详细信息
export function getSellContractWithDetailApi(data) {
  return request({
    url: `/fmsapi/SellManage/GetSellContractWithDetail`,
    method: "post",
    data,
  });
}
